export enum TabKey {
  Summary = "Summary",
  HealthData = "Health Data",
  Orders = "Orders",
  Transactions = "Transactions",
  Referrals = "Referrals",
  LoyaltyLogs = "Loyalty Logs",
}
